import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { Button, HStack, Link, Spinner, Text, VStack } from 'components/uikit';
import { DepositStatus } from 'data/payments/models';

interface PaymentStatusProps {
  status: DepositStatus;
  successRedirectLink: string | null;
  failureRedirectLink: string | null;
}

export function PaymentStatus({
  successRedirectLink,
  failureRedirectLink,
  status,
}: PaymentStatusProps) {
  const { t } = useTranslation('payments');

  const canRedirect = successRedirectLink && failureRedirectLink;

  useEffect(() => {
    if (status === 'PAID' && successRedirectLink) {
      setTimeout(() => {
        window.location.href = successRedirectLink;
      }, 2000);
    }
  }, [status, successRedirectLink]);

  return (
    <VStack spacing='24px'>
      <VStack spacing='0px'>
        <HStack>
          <Text as='h3' fontSize='2xl' fontWeight='medium'>
            {t(`payment_status_${status.toLowerCase()}`)}
          </Text>

          {status === 'MONEY_RECEIVED' || status === 'CREATED' ? (
            <Spinner />
          ) : null}
        </HStack>

        {status === 'PAID' ? (
          canRedirect ? (
            <Text as='h3' fontSize='sm' color='grey.tertiaryText'>
              {t(`payment_status_paid_redirecting`)}
            </Text>
          ) : (
            <Text as='h3' fontSize='sm' color='grey.tertiaryText'>
              {t(`payment_status_paid`)}
            </Text>
          )
        ) : null}
      </VStack>
      <VStack spacing='8px'>
        {status === 'MONEY_RECEIVED' ? null : !canRedirect ? null : (
          <Link
            href={status === 'PAID' ? successRedirectLink : failureRedirectLink}
          >
            <Button w='280px' variant='grey'>
              {t('return_to_the_payment_page')}
            </Button>
          </Link>
        )}
      </VStack>
    </VStack>
  );
}
